/** Mirrors py-rent compute_late_fee — keep in sync (spec §9). */
export function computeLateFeePaise(
  dueDate: string,            // YYYY-MM-DD
  paidDate: string,           // YYYY-MM-DD
  perDayPaise: number | null,
  graceDays: number,
  capPaise: number | null,
): number {
  if (!perDayPaise || perDayPaise <= 0) return 0;
  const due = new Date(dueDate + "T00:00:00Z").getTime();
  const paid = new Date(paidDate + "T00:00:00Z").getTime();
  const daysLate = Math.floor((paid - due) / 86400000);
  const chargeable = Math.max(0, daysLate - graceDays);
  let fee = chargeable * perDayPaise;
  if (capPaise !== null) fee = Math.min(fee, capPaise);
  return fee;
}
